export default {
    home: {
        coreCapabilities: {
            name: 'Core Capabilities',
            title0: 'R&D Innovation',
            description0: 'Continuous investment in R&D, driving pharmaceutical technology innovation',
            title1: 'Quality Assurance',
            description1: 'Strict quality management system, ensuring product safety and reliability',
            title2: 'Global Layout',
            description2: 'International strategy, expanding global markets',
        },
        profile: {
            title: 'Company Profile',
            subtitle: 'About Yongtao',
        },
        companyProfile: {
            name: 'Company Profile',
            specialtyName: 'Our Specialty',
            teamName: 'Our Team',
            missionName: 'Our Mission',
            layoutName: 'National Layout',
            expertise: 'Introducing mature drugs to China, promoting competitive high-quality APIs globally',
            team: 'Composed of medical and pharmaceutical PhDs, lawyers, doctors, and corporate executives',
            mission: 'Promoting impactful healthcare solutions',
            offices: {
                city0: 'Nantong', type0: 'Headquarters (Mainland)',
                city1: 'Hong Kong', type1: 'Headquarters (Global)',
                city2: 'Hangzhou', type2: 'Office',
                city3: 'Chongqing', type3: 'Office',
                city4: 'Shanghai', type4: 'Office',
                city5: 'Hefei', type5: 'Office'
            }
        },
        companyStats: {
            name: 'Company Overview',
            title0: 'Annual Revenue',
            value0: '2.6 Billion Yuan',
            description0: 'Strong revenue achieved in 2023',
            title1: 'Profit Margin',
            value1: '8%',
            description1: 'Solid financial performance',
            title2: 'Professional Team',
            value2: '485+',
            description2: 'Dedicated pharmaceutical experts'
        },
        strategicGoals: {
            name: 'Strategic Goals',
            year0: '2027',
            target0: '3 New Products Annually',
            description0: 'Become the most efficient company in launching new products',
            year1: '2028',
            target1: '$100 Million',
            description1: 'Achieve value target as a specialized pharmaceutical company',
            year2: '2030',
            target2: '$500 Million',
            description2: 'Become an industry leader'
        },
        regions: {
            title: 'Yongtao Pharmaceutical Office System (OA)',
            formLabel0: "Please select a region",
            placeholder0: "Select login region",
            formLabel1: "Employee ID",
            placeholder1: "Enter employee ID",
            formLabel2: "Login Password",
            placeholder2: "Enter login password",
            buttonName: 'Login',
            errorMsg: 'Please fill in complete login information',
            errorNames: ['Account does not exist', 'Password does not match the account'],
            label0: 'Mainland China', value0: 'mainland',
            label1: 'Hong Kong, Macau, Taiwan', value1: 'gat',
            label2: 'Europe', value2: 'europe',
            label3: 'North America', value3: 'north_america',
            label4: 'South America', value4: 'south_america',
            label5: 'Africa', value5: 'africa',
            label6: 'East Asia', value6: 'east_asia',
            label7: 'South Asia', value7: 'south_asia',
            label8: 'Central Asia', value8: 'central_asia',
            label9: 'West Asia', value9: 'west_asia'
        },
        productCategories: {
            name: 'Product Categories',
            name0: 'Prescription Drugs',
            products0: ['Cardiovascular Drugs', 'Antibiotics', 'Digestive System Drugs'],
            name1: 'Over-the-Counter Drugs',
            products1: ['Cold Medicine', 'Pain Relievers', 'Vitamins'],
            name2: 'Health Products',
            products2: ['Nutritional Supplements', 'Health Foods', 'Functional Beverages'],
            name3: 'Medical Devices',
            products3: ['Medical Equipment', 'Medical Consumables', 'Testing Instruments'],
        },
        researchAreas: {
            title: 'Research Areas',
            name0: 'Neurology and Cardiovascular',
            description0: 'Focusing on innovative treatment solutions for neurological diseases and cardiovascular health',
            projects0: ['Metoprolol', 'Cerebrovascular Disease Research'],
            name1: 'Oncology',
            description1: 'Developing innovative anti-cancer drugs and treatment plans',
            projects1: ['Enzalutamide', 'Targeted Therapy'],
            name2: 'Digestive and Respiratory Systems',
            description2: 'Researching and developing treatments for digestive and respiratory system diseases',
            projects2: ['Digestive Enzyme Research', 'Respiratory Therapy'],
        },
        complianceTraining: {
            title: 'Compliance Training',
            categories: {
                title: 'Training Categories',
                list: [
                    'New Employee Onboarding (Quarterly)',
                    'Annual Meeting (Yearly)',
                    'Business Department Meetings (As Needed) - Supply Chain Training (As Needed)',
                    'Online Training (As Needed)'
                ]
            },
            content: {
                title: 'Training Content',
                list: [
                    'Compliance Guidelines and Systems',
                    'Compliant Behavior and Cultural Norms - Reimbursement Policies',
                    'Adverse Reaction Monitoring and Reporting',
                    'Anti-corruption and Commercial Bribery'
                ]
            },
            vision: {
                title: 'Training Vision',
                list: [
                    'Training-based Examinations',
                    'Inspection Result Marking'
                ]
            },
            update: {
                title: 'Content Updates',
                list: [
                    'Annual Updates',
                    'Based on the Latest RDPAC Requirements - Based on Partner Compliance System Requirements',
                    'Based on Internal and External Audit Results'
                ]
            }
        },
    },
    menu: {
        home: 'Home',
        resources: 'Resources',
        about: 'About Us',
        contact: 'Contact'
    },
    hero: {
        title: 'Yongtao Pharmaceutical',
        subtitle: 'Creating a New Era in Professional Pharmaceutical Industry',
        description: 'Yongtao is a first-class pharmaceutical company setting new industry benchmarks with its excellence in delivering innovative products to the Chinese market',
        learnMore: 'Learn More',
        oaSystem: 'Employee Portal (OA)'

    },
    sections: {
        capabilities: 'Core Capabilities',
        research: 'Research Areas',
        profile: 'Company Profile',
        products: 'Product Categories',
        goals: 'Strategic Goals',
        overview: 'Company Overview',
        compliance: 'Compliance Training'
    },
    oa: {
        title: 'Yongtao Pharmaceutical OA System',
        region: 'Select Region',
        employeeId: 'Employee ID',
        password: 'Password',
        login: 'Login',
        errors: {
            incomplete: 'Please complete all login information',
            noAccount: 'Account not found',
            wrongPassword: 'Incorrect password'
        }
    },
    about: {
        title: 'About Yongtao',
        subtitle: 'Emerging Leader in Pharmaceutical and Chemical Industry',
        company: {
            title: 'Company Profile',
            description: 'Yongtao is an emerging leader in the pharmaceutical and chemical industry, strategically headquartered in Nantong, China. We have offices across the country, including Hangzhou, Chongqing, Hong Kong, Shanghai, and Hefei. Founded in 2022 by experienced pharmaceutical executives and financially strong investors, Yongtao combines agility with expertise to form dynamic and reliable partnerships.'
        },
        mission: {
            title: 'Our Mission',
            description: 'To nurture and integrate proven pharmaceutical products into the Chinese market, ensuring they align with China\'s unique needs and standards while fostering a strong network of partnerships.'
        },
        strategicGoals: {
            title: 'Strategic Goals',
            goals: {
                goal2028: {
                    title: '2028 Goal',
                    description: 'Become a $100 million professional pharmaceutical company by investing in R&D to promote innovation, strengthening partnerships with healthcare institutions, and enhancing market penetration strategies.'
                },
                goal2030: {
                    title: '2030 Vision',
                    description: 'Transform into a $500 million company focusing on expanding operational scale and efficiency, streamlining manufacturing processes, and leveraging emerging technology advantages for cost-effective production.'
                },
                innovation: {
                    title: 'Product Innovation',
                    description: 'From 2027, become the most effective company in new product launches, introducing three professional new products annually through continued investment in frontier research and fostering cross-functional collaboration.'
                }
            }
        },
        capabilities: {
            title: 'Core Capabilities',
            items: {
                innovation: {
                    title: 'R&D Innovation',
                    description: 'Actively engage in domestic R&D work, dedicated to creating innovative, locally customized pharmaceuticals while staying at the forefront of developing impactful healthcare solutions in China through strategic partnerships with leading research institutions.'
                },
                collaboration: {
                    title: 'Global Collaboration',
                    description: 'Serve as the preferred partner for foreign companies entering the Chinese market, offering efficient product registration and profitable market strategies. Our expert team ensures all products enter the market seamlessly and legally.'
                },
                network: {
                    title: 'Strategic Network',
                    description: 'Through our network of strategic offices across the country, including Nantong, Hangzhou, Chongqing, Hong Kong, Shanghai, and Hefei, we can meet diverse project needs with excellence and agility.'
                }
            }
        }
    },
    contact: {
        companyName: 'Hong Kong Yongtao Pharmaceutical Co., Ltd.',
        address: 'Room 4, 16/F, Ho King Commercial Centre, 2-16 Fa Yuen Street, Mong Kok, Hong Kong',
        phone: '+86 18651110588',
        email: 'hao.xiaofeng@yongtao-hk.com',
        logoAlt: 'Yongtao Pharmaceutical',
        mapTitle: 'Hong Kong Yongtao Pharmaceutical Co., Ltd.'
    },
    products: {
        title: 'Products',
        subtitle: 'Yongtao Pharmaceutical is committed to providing high-quality and reliable pharmaceutical products for patients',
        categories: {
            neurological: {
                name: 'Neurological System',
                products: {
                    flunarizine: {
                        name: 'Flunarizine Hydrochloride Capsules',
                        description: 'For the prevention and treatment of migraine and vascular headaches'
                    },
                    levodopa: {
                        name: 'Levodopa and Benserazide Tablets',
                        description: 'For the treatment of Parkinson\'s disease'
                    }
                }
            },
            cardiovascular: {
                name: 'Cardiovascular System',
                products: {
                    metoprolol: {
                        name: 'Metoprolol Tartrate Tablets',
                        description: 'For the treatment of cardiovascular diseases such as hypertension and angina'
                    },
                    sacubitril: {
                        name: 'Sacubitril Valsartan Sodium Tablets',
                        description: 'For the treatment of chronic heart failure'
                    }
                }
            },
            antiviral: {
                name: 'Antiviral and Oncology',
                products: {
                    peramivir: {
                        name: 'Peramivir Injection',
                        description: 'For the treatment of influenza virus infection'
                    },
                    enzalutamide: {
                        name: 'Enzalutamide Soft Capsules',
                        description: 'For the treatment of prostate cancer'
                    }
                }
            }
        }
    },
    resources: {
        title: 'Resources Center',
        subtitle: 'Innovative Pharmaceutical Solutions',
        categories: {
            neurological: {
                name: 'Neurological System',
                products: {
                    flunarizine: {
                        name: 'Flunarizine Hydrochloride Capsules',
                        description: 'For the prevention and treatment of migraine and dizziness, improving cerebral blood circulation'
                    },
                    levodopa: {
                        name: 'Levodopa and Benserazide Tablets',
                        description: 'For the treatment of Parkinson\'s disease, improving motor function'
                    }
                }
            },
            cardiovascular: {
                name: 'Cardiovascular System',
                products: {
                    metoprolol: {
                        name: 'Metoprolol Tartrate Tablets',
                        description: 'For the treatment of hypertension, angina, and arrhythmia'
                    },
                    sacubitril: {
                        name: 'Sacubitril Valsartan Sodium Tablets',
                        description: 'For the treatment of chronic heart failure'
                    }
                }
            },
            antitumor: {
                name: 'Antitumor Drugs',
                products: {
                    enzalutamide: {
                        name: 'Enzalutamide Soft Capsules',
                        description: 'For the treatment of castration-resistant prostate cancer'
                    }
                }
            }
        },
        tags: {
            migraine: 'Migraine',
            dizziness: 'Dizziness',
            prescription: 'Prescription Drugs',
            parkinsons: 'Parkinson\'s',
            movement_disorder: 'Movement Disorder',
            hypertension: 'Hypertension',
            angina: 'Angina',
            heart_failure: 'Heart Failure',
            innovative: 'Innovative Drugs',
            tumor: 'Tumor'
        }
    },
    footer: {
        contact: {
            title: 'Contact Us',
            phone: '+86 18651110588',
            email: 'hao.xiaofeng@yongtao-hk.com',
            address: 'Room 4, 16/F, Good Luck Industrial Building, 2-16 Fa Yuen Street, Mong Kok, Hong Kong'
        },
        quickLinks: {
            title: 'Quick Links',
            resources: 'Resources',
            about: 'About Us',
            contact: 'Contact Us'
        },
        social: {
            title: 'Follow Us'
        },
        copyright: 'Hong Kong Yongtao Pharmaceutical Co., Ltd. All rights reserved'
    }

}